function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import _ from 'lodash';
import { markdownify, Link, safePrefix } from '../utils';

var Intro =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Intro, _React$Component);

  function Intro() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Intro.prototype;

  _proto.render = function render() {
    return React.createElement("div", {
      id: _.get(this.props, 'section.section_id'),
      className: "intro"
    }, React.createElement("div", {
      className: "intro-text"
    }, markdownify(_.get(this.props, 'section.content'))), _.get(this.props, 'section.actions') && React.createElement("p", {
      className: "intro-cta"
    }, _.map(_.get(this.props, 'section.actions'), function (action, action_idx) {
      return React.createElement(Link, {
        key: action_idx,
        to: safePrefix(_.get(action, 'url')),
        className: "button"
      }, _.get(action, 'label'));
    })));
  };

  return Intro;
}(React.Component);

export { Intro as default };